module.exports = __webpack_public_path__ + "img/python-logo.a0fa797c.png";